import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';

export default function QuestCard({ quest, onAdvance }) {
  var progressPct = quest.total > 0 ? (quest.current / quest.total) * 100 : 0;

  return (
    <TouchableOpacity onPress={onAdvance} activeOpacity={0.7} style={[s.card, quest.done && s.cardDone]}>
      <Icon name={quest.icon} size={22} color={quest.done ? Colors.green : Colors.primary} />
      <View style={s.content}>
        <Text style={[s.name, quest.done && s.nameDone]}>{quest.name}</Text>
        {!quest.done && (
          <View style={s.progressRow}>
            <View style={s.progressDot} />
            <View style={s.progressBar}>
              <View style={[s.progressFill, { width: progressPct + '%' }]} />
            </View>
            <Text style={s.progressText}>{quest.current + '/' + quest.total}</Text>
          </View>
        )}
        {quest.done && (
          <View style={s.doneRow}>
            <Icon name="checkmark-circle" size={16} color={Colors.green} />
            <Text style={s.doneText}>Complete!</Text>
          </View>
        )}
      </View>
      {!quest.done && <Icon name="chevron-forward" size={18} color={Colors.primary} />}
    </TouchableOpacity>
  );
}

var s = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    backgroundColor: Colors.card,
    borderRadius: 16,
    padding: 14,
    paddingHorizontal: 16,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  cardDone: {
    backgroundColor: Colors.greenLight,
    borderColor: 'rgba(76,175,80,0.3)',
  },
  content: { flex: 1 },
  name: { fontSize: 15, fontWeight: '600', color: Colors.textDark },
  nameDone: { textDecorationLine: 'line-through' },
  progressRow: { flexDirection: 'row', alignItems: 'center', gap: 8, marginTop: 6 },
  progressDot: { width: 14, height: 14, borderRadius: 7, backgroundColor: Colors.accent },
  progressBar: { flex: 1, height: 6, backgroundColor: 'rgba(0,0,0,0.08)', borderRadius: 3, maxWidth: 120 },
  progressFill: { height: '100%', backgroundColor: Colors.accent, borderRadius: 3 },
  progressText: { fontSize: 12, color: Colors.textMid, fontWeight: '600' },
  doneRow: { flexDirection: 'row', alignItems: 'center', gap: 6, marginTop: 4 },
  doneText: { fontSize: 12, color: Colors.green, fontWeight: '600' },
});
